'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'dumbbell';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f44b';
var svgPathData = 'M208 64c8.8 0 16 7.2 16 16l0 176 0 176c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64 0-224 0-64c0-8.8 7.2-16 16-16l32 0zM128 413.3l0 18.7c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-160 128 0 0 160c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-18.7c5 1.8 10.4 2.7 16 2.7l32 0c26.5 0 48-21.5 48-48l0-96 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-96c0-26.5-21.5-48-48-48l-32 0c-5.6 0-11 1-16 2.7L512 80c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48l0 160-128 0 0-160c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48l0 18.7C123 97 117.6 96 112 96L80 96c-26.5 0-48 21.5-48 48l0 96-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 96c0 26.5 21.5 48 48 48l32 0c5.6 0 11-1 16-2.7zM512 144c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 112 0 112c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-224zM480 368l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-176 0-176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64 0 224zM128 144l0 224c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-112 0-112c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDumbbell = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;